import React from "react";
import { Helmet } from "react-helmet";
import LayoutHome from "../components/layout/layout-home";
import styled from "styled-components";
import Testimonial from "../library/testimonial";
import ParagraphNormal from "../library/paragraph/paragraph";
import Heading2 from "../library/headings/heading2";
import CtaPanel from "../components/cta";
import Banner from "../library/banner";
import { Link } from "gatsby";
import { PHONE } from "../styles/breakpoints";
import Callout from "../library/callout";
import GraphIcon from "../assets/images/graph-1.png";
import DoorIcon from "../assets/images/door-1.png";
import TrophyIcon from "../assets/images/trophy-1.png";
import NetworkIcon from "../assets/images/network-1.png";
import TestLogo from "../assets/images/ech-logo.png";
import {
  ButtonSecondary,
  Columns,
  ContainerSpacer,
  Divider,
  Icon
} from "../styles/shared";
import TextInput from "../library/inputs/text";
import Button from "../library/buttons/button";

const Main = styled.div`
  max-width: 1000px;
  margin: auto;
  @media (max-width: 769px) and (min-width: 320px) {
    width: 90%;
    margin: auto;
  }
  iframe {
    ${PHONE} {
      width: 100%;
      height: auto;
    }
  }
`;

const Container = styled.div`
  margin: 50px 0 0 0;
`;

const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 600px;
  margin: 0 auto 45px auto;
  input {
    width: 100%;
  }
`;

const Flex = styled.div`
  display: flex;
  margin: 0 0 25px 0;
  width: 100%;
`;

const Grid = styled.div`
  display: grid;
  margin: 50px 0;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 50px;
  text-align: center;
  ${PHONE} {
    grid-template-columns: 1fr 1fr;
  }
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  p {
    padding: 0;
    margin: 10px 0;
  }
`;

const MobileSpacer = styled.div`
  ${PHONE} {
    height: 40px;
  }
`;

const index = () => {
  return (
    <>
      <Helmet>
        <title>The Employee Referral App for Social Care - Care Friends</title>
        <link rel="canonical" href="/" />
        <meta
          name="description"
          content="Employee referrals are the highest quality source of new staff for frontline care. The Care Friends App makes your referral scheme more effective and simple to run."
        />
      </Helmet>
      <LayoutHome>
        <Container>
          <Main id="demo" style={{ margin: "auto" }}>
            <div style={{ textAlign: "center", marginBottom: 50 }}>
              <iframe
                  src="https://player.vimeo.com/video/552738315"
                  width="640"
                  height="360"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
              />
            </div>
            <Heading2 align="center" title="Request a quote" />
            <Form
              name="contact"
              method="post"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              action="/success/"
            >
              {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
              <input type="hidden" name="form-name" value="contact" />
              <input type="hidden" name="bot-field" />
              <Flex>
                <TextInput
                  placeholder="Your Name"
                  type="text"
                  name="your-name"
                  required={true}
                />
              </Flex>
              <Flex>
                <TextInput
                  placeholder="Your Organisation"
                  type="text"
                  name="your-org"
                  required={true}
                />
              </Flex>
              <Flex>
                <TextInput
                  placeholder="Your Email"
                  type="email"
                  name="email-address"
                  required={true}
                />
              </Flex>
              <Flex>
                <TextInput
                  placeholder="Phone Number"
                  type="text"
                  name="phone-number"
                  required={true}
                />
              </Flex>

              <Flex>
                <TextInput
                  placeholder="How many employees does your organisation have in total?"
                  type="text"
                  name="how-man-employees"
                  required={true}
                />
              </Flex>
              <Flex>
                <Button title="Submit" type="submit" />
              </Flex>
            </Form>
          </Main>
          <Callout color="#f5f5f5">
            <Main>
              <ContainerSpacer>
                <Columns>
                  <div>
                    <Heading2 title="Why Care Friends?" />
                    <ParagraphNormal>
                      Finding the right quality of care staff is a major
                      challenge.
                    </ParagraphNormal>
                    <ParagraphNormal>
                      Employee referral programs are the proven best source of
                      high-performing employees, but a hassle to administer and
                      hard to keep top-of-mind with staff.
                    </ParagraphNormal>
                    <ParagraphNormal>
                      As a result they only deliver a fraction of their true
                      potential.
                    </ParagraphNormal>
                    <ParagraphNormal>
                      Care Friends is an app developed by Neil Eastwood, author
                      of Saving Social Care, that changes all that.
                    </ParagraphNormal>
                    <Link
                      style={{ display: "flex", textDecoration: "none" }}
                      to="#demo"
                    >
                      <ButtonSecondary>Get a Quote</ButtonSecondary>
                    </Link>
                  </div>
                  <div>
                    <span>
                      <MobileSpacer />
                      <Banner img="mobile" overlay={false} borderRadius={10} />
                    </span>
                  </div>
                </Columns>
              </ContainerSpacer>
            </Main>
          </Callout>
          <Main>
            <ContainerSpacer>
              <div style={{ maxWidth: 500, margin: "auto" }}>
                <Heading2 align="center" title="Key benefits" />
              </div>
              <Grid>
                <Icon>
                  <img src={GraphIcon} width={50} alt="icon"/>
                  <Divider />
                  <ParagraphNormal>
                    Increased employee referrals compared to a manual referral
                    scheme.
                  </ParagraphNormal>
                </Icon>
                <Icon>
                  <img src={DoorIcon} width={50} alt="icon"/>
                  <Divider />
                  <ParagraphNormal>
                    27% higher retention rates for employee referrals.
                  </ParagraphNormal>
                </Icon>
                <Icon>
                  <img src={TrophyIcon} width={50} alt="icon"/>
                  <Divider />
                  <ParagraphNormal>
                    Increased employee participation via the use of micro
                    rewards and gamification.
                  </ParagraphNormal>
                </Icon>
                <Icon>
                  <img src={NetworkIcon} width={50} alt="icon"/>
                  <Divider />
                  <ParagraphNormal>
                    Easy to use recruiter platform for prompt referral
                    management.
                  </ParagraphNormal>
                </Icon>
              </Grid>
            </ContainerSpacer>
          </Main>
          <Callout color="#f5f5f5">
            <Main>
              <Testimonial
                quote
                style={{ padding: "50px 0" }}
                person="Narelle Milne, HR Manager ECH Inc. Australia"
                testimonial="“Both the uptake of our employees using the Care Friends app and the number of referrals we have received through it have really pleased us. The simplicity of the app makes referring easy for our staff, and the quality of candidates has clearly been better than those coming from job boards.”"
                logo={TestLogo}
              />
            </Main>
          </Callout>
          <CtaPanel />
        </Container>
      </LayoutHome>
    </>
  );
};

export default index;
